import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Calendar } from "lucide-react";
import api from "../lib/api";
import Seo from "../components/Seo";

export default function Blog() {
  const [posts, setPosts] = useState([]);
  useEffect(() => { api.get("/public/blog").then((r) => setPosts(r.data)).catch(() => {}); }, []);

  return (
    <div data-testid="blog-page">
      <Seo path="/blog" title="The Seasons Journal — stories from the studio"
        description="Warm, friendly writing from our East Croydon art studio — studies of artists, tips for beginners and stories from our 14-week courses." />
      <section className="max-w-7xl mx-auto px-6 lg:px-10 pt-16 pb-12">
        <div className="font-hand text-[#A685BD] text-2xl">stories from the studio</div>
        <h1 className="font-display text-5xl md:text-6xl text-[#5D2C8F] mt-2 brush-underline">The Seasons Journal</h1>
      </section>

      <section className="max-w-7xl mx-auto px-6 lg:px-10 pb-24">
        {posts.length === 0 && (
          <div className="soft-card p-10 text-center">
            <div className="font-display text-2xl text-[#5D2C8F]">Our first stories are drying on the easel.</div>
            <p className="text-[#5A4A6B] mt-3">Check back soon — we publish a fresh post every week.</p>
          </div>
        )}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {posts.map((p) => (
            <Link key={p.id} to={`/blog/${p.slug}`} className="soft-card p-0 overflow-hidden group" data-testid={`blog-card-${p.slug}`}>
              {p.cover_image && (
                <div className="aspect-[4/3] overflow-hidden">
                  <img src={p.cover_image} alt="" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
                </div>
              )}
              <div className="p-6">
                <div className="flex items-center gap-2 text-xs text-[#8A6DA3]"><Calendar size={12} /> {new Date(p.published_at || p.created_at).toLocaleDateString("en-GB")}</div>
                <h2 className="font-display text-2xl text-[#5D2C8F] mt-2 leading-snug">{p.title}</h2>
                <p className="text-sm text-[#5A4A6B] mt-2 leading-relaxed">{p.excerpt}</p>
                <div className="mt-4 text-sm text-[#A685BD] inline-flex items-center gap-1">Read more <ArrowRight size={14} /></div>
              </div>
            </Link>
          ))}
        </div>
      </section>
    </div>
  );
}
